const config = {
  api: {
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
    endpoints: {
      auth: {
        register: '/auth/register',
        login: '/auth/login',
        setPassword: '/auth/set-password',
        validateHash: (hash) => `/auth/validate-hash/${hash}`,
        validateToken: '/auth/validate-token',
        resetPassword: (userId) => `/auth/reset-password/${userId}`,
        logout: '/auth/logout',
      },
      admin: {
        users: '/admin/users',
        updateSocialNetworks: (userId) => `/admin/users/${userId}/social-networks`,
      },
    },
  },

  frontend: {
    baseURL: process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000',
    routes: {
      home: '/',
      activate: (hash) => `/activate/${hash}`,
      cabinet: '/cabinet',
      admin: '/admin',
    },
  },

  social: {
    telegram: {
      username: process.env.REACT_APP_TELEGRAM_USERNAME || 'salematic',
      url: (username) => `https://t.me/${username}`,
    },
    whatsapp: {
      number: process.env.REACT_APP_WHATSAPP_NUMBER || '77478693327',
      url: (number) => number ? `https://wa.me/${number}` : 'https://wa.me',
    },
    teams: {
      // Открывает чат в Microsoft Teams с указанным пользователем (должен быть залогинен в Teams)
      url: 'https://teams.live.com/l/invite/FEATBMxjPHQE524dgU?v=g1',
    },
  },

  app: {
    name: 'TraffShield',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    environment: process.env.NODE_ENV || 'development',
  },

  errors: {
    serverNotRunning: 'Произошла ошибка при подключении к серверу. Убедитесь, что сервер запущен.',
    registrationFailed: 'Ошибка при регистрации',
    networkError: 'Ошибка сети. Проверьте подключение к интернету.',
  },
};

export const getApiUrl = (endpoint) => {
  return `${config.api.baseURL}${endpoint}`;
};

export const getFrontendUrl = (route) => {
  return `${config.frontend.baseURL}${route}`;
};

export const getTelegramUrl = () => {
  return config.social.telegram.url(config.social.telegram.username);
};

export const getWhatsAppUrl = () => {
  return config.social.whatsapp.url(config.social.whatsapp.number);
};

export const getTeamsUrl = () => {
  return config.social.teams.url;
};

export const getActivationLink = (hash) => {
  return getFrontendUrl(config.frontend.routes.activate(hash));
};

export default config;

